(function(){
    angular
        .module('app')
        .directive('ngExtrainfo', extrainfo);

        extrainfo.$inject = ['AnalisisService','GenerallabService','$timeout'];
        function extrainfo(AnalisisService,GenerallabService,$timeout){
            return {
            	restrict:'E',
		        scope: {
		          	formulario:'=',
		          	aextra:'=',
		          	pet:'=',
		          	parent:'='
		          	//muestra:"="
	            },
	           	template: '<div ng-include="getTemplateUrl()"></div>',

	            /*templateUrl: function(element,$attrs){
	            	console.log($attrs);
	            	return '/uranolab/extrainfo?lang_id='+lang_id+"&form="+$attrs.formulario+"[[formulario]]";
	            },*/
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.generalLab = GenerallabService;
		            	scope.formConfirmar = scope.parent.formConfirmar;
		            	
		            	console.log("extrainfo",scope);
		            	//console.log($.material);
		            	scope.subanaliticas = [];
		            	scope.seleccionadas = [];
		            	scope.selectores = [];
		            	scope.step_rabiaf = 0;
		            	scope.getstep_rabiaf = function()
		            	{
		            		if(scope.step_rabiaf<4){
			            		scope.aextra.analitica.blockContinue=true;
			            	}else{
			            		scope.aextra.analitica.blockContinue=false;
			            	}
		            		return scope.step_rabiaf;
		            	}
		            	scope.getTemplateUrl = function () {
		            		/*$timeout(function(){
								$.material.init();
		            		},500)*/
	            			return '/uranolab/extrainfo?lang_id='+lang_id+"&form="+scope.formulario;

			            }
						
						scope.step1 = function(form){
							
							form.$setSubmitted();

							if(
								form["fecha_recogida"+scope.aextra.analitica.id ].$valid &&
								form["vacuna"+scope.aextra.analitica.id ].$valid &&
								form["lote"+scope.aextra.analitica.id ].$valid &&
								form["fecha_vacunacion"+scope.aextra.analitica.id ].$valid &&
								form["pais_destino"+scope.aextra.analitica.id ].$valid 
								
								)
							{
								form.$setPristine();
								scope.step_rabiaf = scope.step_rabiaf +1
	

							}
						}

						scope.step2 = function(form){
				
							form.$setSubmitted();

							if(
								form["especie"+scope.aextra.analitica.id ].$valid &&
								form["raza"+scope.aextra.analitica.id ].$valid &&
								form["nombre_animal"+scope.aextra.analitica.id ].$valid &&
								form["fecha_nacimiento"+scope.aextra.analitica.id ].$valid &&
								form["chip"+scope.aextra.analitica.id ].$valid 
								
								)
							{
								form.$setPristine();
								scope.step_rabiaf = scope.step_rabiaf +1
			

							}
						}

						scope.step3 = function(form){
				
							form.$setSubmitted();

							if(
								form["nombre"+scope.aextra.analitica.id ].$valid &&
								form["direccion"+scope.aextra.analitica.id ].$valid &&
								form["provincia"+scope.aextra.analitica.id ].$valid &&
								form["codigo_postal"+scope.aextra.analitica.id ].$valid &&
								form["telf"+scope.aextra.analitica.id ].$valid &&
								form["email"+scope.aextra.analitica.id ].$valid 
								
								)
							{
								form.$setPristine();
								scope.step_rabiaf = scope.step_rabiaf +1
			

							}
						}

						scope.step4 = function(form){
				
							form.$setSubmitted();

							if(
								form["vet_nombre"+scope.aextra.analitica.id ].$valid &&
								form["vet_licencia"+scope.aextra.analitica.id ].$valid &&
								form["vet_direccion"+scope.aextra.analitica.id ].$valid &&
								form["vet_provincia"+scope.aextra.analitica.id ].$valid &&
								form["vet_codigo_postal"+scope.aextra.analitica.id ].$valid &&
								form["vet_telf"+scope.aextra.analitica.id ].$valid &&
								form["vet_email"+scope.aextra.analitica.id ].$valid 
								
								)
							{
								form.$setPristine();
								scope.step_rabiaf = scope.step_rabiaf +1
			

							}
							
						}

						scope.setstep_rabiaf = function(v)
		            	{
		            		scope.step_rabiaf = v;
		            		return scope.step_rabiaf;
		            	}
			      
			            scope.getVacunas = function(){
                      		AnalisisService.getInfoVacunas(scope.aextra,function(data){
                      			$timeout(function(){
                      				scope.subanaliticas = data.subanaliticas;
                      				scope.peticionRelacionada = data.peticionRelacionada;
                      			});
                      		});
			            	console.log("getvacunas");
			            }

			            scope.contarSeleccionados = function(){
			            	scope.seleccionadas = [];
			            	for(var cont=0;cont<scope.subanaliticas.length;cont++){
			            		if(scope.subanaliticas[cont].checked){
			            			scope.seleccionadas.push(scope.subanaliticas[cont]);
			            		}
			            	}
			            }

			            scope.reiniciadoFoto = false;
 						scope.reiniciarFoto = function(muestraUn){
			            	scope.reiniciadoFoto = true;
			            	$timeout(function(){
				            	scope.reiniciadoFoto = false;
 								muestraUn.foto_lesion = "";
			            	})
			            	//console.log("REINICIANDOs",value);
			            }

			            scope.buscarVeterinario = function(vet_id){
			            	var res= false;
			            	if(angular.isDefined(scope.generalLab.centros[0].veterinariosCentro) && vet_id){
			            		for(var cont =0 ;cont<scope.generalLab.centros[0].veterinariosCentro.length && !res;cont++){
			            			if(vet_id==scope.generalLab.centros[0].veterinariosCentro[cont].id){
			            				res = scope.generalLab.centros[0].veterinariosCentro[cont];
			            				scope.aextra.info.veterinario.nombre_apellidos = res.nombre+" "+res.apellidos;
			            				scope.aextra.info.veterinario.id_colegiado = res.id_colegiado;
			            				scope.aextra.info.veterinario.email = res.email;
			            			}
			            		}
			            	}
			            	console.log(res);
			            	//return res;
			            }


			            scope.reiniciarFotoOrgano = function(muestraUn){
			            	scope.reiniciadoFotoOrgano = true;
			            	$timeout(function(){
				            	scope.reiniciadoFotoOrgano = false;
 								muestraUn.foto_organo = "";
			            	})
			            	//console.log("REINICIANDOs",value);
			            }


			            scope.getCitologiaInfo = function(){
			            	AnalisisService.getInfoCitologia(function(data){
                      			scope.selectores = data;
                      		});
			            }

			            scope.preseleccionarVacunas = function(){
			            	AnalisisService.getInfoVacunasChecked(scope.aextra.peticion_rel,function(data){
			            		for(var cont2=0;cont2<scope.subanaliticas.length;cont2++){
				            		scope.subanaliticas[cont2].checked=false;
			            		}
			            		for(var cont=0;cont<data.resultadosPositivos.length;cont++){
			            			var res = false;
				            		for(var cont2=0;cont2<scope.subanaliticas.length && !res;cont2++){
				            			if(data.resultadosPositivos[cont].code == scope.subanaliticas[cont2].codigo_alfa){
				            				scope.subanaliticas[cont2].checked=true;
				            				res = true;
				            			}
				            		}
				            	}
			            		scope.contarSeleccionados();

                      		
                      		});
			            	/*for(var cont=0;cont<scope.subanaliticas.length;cont++){
			            		if(scope.subanaliticas[cont].pre_checked){
			            			scope.subanaliticas[cont].checked = true;
			            		}
			            	}
			            	scope.contarSeleccionados();*/
			            }
		            });
		        }
          }
      	}
})();